/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// console.log($(".Product__SlideItem:first-of-type").find('.ModelWrapper').length);

//  if (($(".Product__SlideItem:first-of-type").find('.ModelWrapper').length != 1) && $(".Product__SlideItem--model").length === 1 &&  parseInt($('.Product__SlideshowNavImage').length) > 1) {
//      console.log('activated');
//     $(".Product__SlideshowNavImage:last-of-type").css('display','none');
//     $('.ModelWrapper').css('display','none');
//     $('.Product__Slideshow').append($('.ModelWrapper'));

//     /*Click Event*/
//     $("#toggle").on('click', function() {
//         if($(this).hasClass('active')) {
//             $('.ModelWrapper').css('display','none');
//             $('.flickity-viewport').css('display','block');
//             $(this).removeClass('active');
//         } else {
//             $('.ModelWrapper').css('display','block');
//             $('.flickity-viewport').css('display','none');
//             $(this).addClass('active');
//         }
//     });     
// } else {
//     console.log('not activated');
//     $('.toggle-container').remove();
// }


if (productID) {
    switch (productID) {
        case 6721595768898:
        case 6721476362306:
        case 6721475575874:
        case 6721598488642:
            $(".shopify-payment-button__button").text('GO TO METAVERSE POP-UP');
            $(".shopify-payment-button__button").attr("href", "https://play.decentraland.org/?position=2,22");
            break;
        case 6721597374530:
            //005
            $(".shopify-payment-button__button").attr("href", "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/110153530944702110034051120919946650050567561022570729780623751699961168789505");
            break;
        case 6721600028738:
            //006
            $(".shopify-payment-button__button").attr("href", "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/110153530944702110034051120919946650050567561022570729780623751701060680417281");
            break;
        case 6721594163266:
            //007
            $(".shopify-payment-button__button").attr("href", "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/110153530944702110034051120919946650050567561022570729780623751708757261811713");
            break;
        case 6721594589250:
            //008
            $(".shopify-payment-button__button").attr("href", "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/110153530944702110034051120919946650050567561022570729780623751703259703672833");
            break;
        case 6721593737282:
            //009
            $(".shopify-payment-button__button").attr("href", "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/110153530944702110034051120919946650050567561022570729780623751704359215300609");
            break;
        case 6721596391490:
            //010
            $(".shopify-payment-button__button").attr("href", "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/110153530944702110034051120919946650050567561022570729780623751705458726928385");
            break;
        case 6721477017666:
            //011
            $(".shopify-payment-button__button").attr("href", "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/110153530944702110034051120919946650050567561022570729780623751707657750183937");
            break;
        case 6721475608642:
            //012
            $(".shopify-payment-button__button").attr("href", "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/110153530944702110034051120919946650050567561022570729780623751709856773439489");
            break;
        case 6721599635522:
            //013
            $(".shopify-payment-button__button").attr("href", "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/110153530944702110034051120919946650050567561022570729780623751710956285067265");
            break;
        case 6721476788290:
            //014
            $(".shopify-payment-button__button").attr("href", "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/110153530944702110034051120919946650050567561022570729780623751712055796695041");
            break;
        case 6729013559362:
            //015
            $(".shopify-payment-button__button").attr("href", "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/110153530944702110034051120919946650050567561022570729780623751713155308322817");
            break;
        case 6731397595202:
            //016
            $(".shopify-payment-button__button").text('VIEW ON OPEN SEA');
            $(".shopify-payment-button__button").attr("href", "https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/110153530944702110034051120919946650050567561022570729780623751718652866461697");
            break;
        default:
    }
}

$('.js-tilt').tilt({
    glare: true,
    maxGlare: .5
})

/*Click Event*/
$(".metaverse-roadmap").on('click', '.metaverse-pill', function () {
    let thisid = $(this).attr('id');
    $(this).siblings().removeClass('active');
    $(this).addClass('active');
    $('.metaverse-dynamic').find('.section').css('opacity', '0');
    $('.metaverse-dynamic').find('.section').removeClass('active');
    $('.metaverse-dynamic').find('div[data=' + thisid + ']').css('opacity', '1');
    $('.metaverse-dynamic').find('div[data=' + thisid + ']').addClass('active');
});

$("#chart-toggle").on('click', function () {
    $(this).toggleClass("on");
    if ($(this).hasClass("on")) {
        $('.sizing-chart-container').slideDown();
    } else {
        $('.sizing-chart-container').slideUp();
    }
});

$('.meta-slider-container').flickity({
    imagesLoaded: true
});

$(".disclosure").on('click', '.notice-title', function () {
    if ($(this).parent().hasClass('open')) {
        $(this).parent().removeClass('open');
        $(this).next('.more-info').css('display', 'none');
    } else {
        $(this).parent().addClass('open');
        $(this).next('.more-info').css('display', 'block');
    }
});


$('.tab-trigger').click(function() {
    // Remove 'active' class from all tab triggers
    $('.tab-trigger').removeClass('active');
    // Hide all tab containers
    $('.tab-container').hide();

    // Add 'active' class to the clicked tab trigger
    $(this).addClass('active');
    // Get the data-id attribute value of the clicked tab trigger
    var tabId = $(this).attr('id');

    // Show the corresponding tab container based on the tabId
    $('.tab-container[data-id="' + tabId + '"]').show();
});

const phoneInputField = document.querySelector("#phone");
const phoneInput = window.intlTelInput(phoneInputField, {
    separateDialCode:
        true,
    hiddenInput: 
        "full",
    utilsScript:
        "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
});